import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Tags = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`
